import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import EmptyState from "../../../lib/components/EmptyState";
import moment from "moment";
import { moneyFormat } from "../../../utils/moneyFormat";

const RemDataTable = ({ data = [], isLoading, page = 1, pageSize = 20 }) => {
  if (isLoading) return null;

  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead className="bg-light">
            <TableRow>
              <TableCell>S/N</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Transaction ID</TableCell>
              <TableCell>Bank Account</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item, idx) => {
              const serialNumber = (page - 1) * pageSize + idx + 1;
              const bank = item?.accountPaidTo?.bankName || "Bank";
              const last4 = item?.accountPaidTo?.accountNumber
                ? item.accountPaidTo.accountNumber.slice(-4)
                : "";
              const accountStr = `${bank} •••• ${last4}`;

              return (
                <TableRow
                  key={item?.transactionId || item?.id || idx}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{serialNumber}</TableCell>
                  <TableCell>
                    {moment(item?.date).format("Do MMM, YYYY")}
                  </TableCell>
                  <TableCell>
                    <span className="fw-medium">
                      {item?.transactionId || "N/A"}
                    </span>
                  </TableCell>
                  <TableCell>{accountStr}</TableCell>
                  <TableCell>{moneyFormat(item?.amount, "NGN")}</TableCell>
                  <TableCell>
                    <StatusBadge status={item?.status} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <EmptyState isEmpty={!isLoading && !data?.length} />
    </Paper>
  );
};

function StatusBadge({ status }) {
  const s = String(status).toLowerCase();
  if (s === "completed") {
    return (
      <div className="badge rounded-pill fw-medium fs-sm bg-success text-success bg-opacity-25">
        Completed
      </div>
    );
  }
  if (s === "processing") {
    return (
      <div className="badge rounded-pill fw-medium fs-sm bg-primary text-primary bg-opacity-25">
        Processing
      </div>
    );
  }
  if (s === "failed") {
    return (
      <div className="badge rounded-pill fw-medium fs-sm bg-danger text-danger bg-opacity-25">
        Failed
      </div>
    );
  }
  if (s === "pending") {
    return (
      <div className="badge rounded-pill fw-medium fs-sm bg-warning text-warning bg-opacity-25">
        Pending
      </div>
    );
  }
  return (
    <div className="badge rounded-pill fw-medium fs-sm bg-secondary text-secondary bg-opacity-25">
      {status || "Unknown"}
    </div>
  );
}

export default RemDataTable;
